import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '../src/styles/modile.css'
import '../src/styles/media.css'

ReactDOM.render(<App />, document.getElementById('root'));
